import { Link } from 'react-router-dom';
import { articles, type Article } from '@/mocks/articles';

export default function HotGrid() {
  const hotArticles: Article[] = articles.filter((a) => a.isHot).slice(0, 4);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50" data-product-shop="">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            🔥 热门爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            全网最受关注的独家猛料，实时热度排行
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {hotArticles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {index === 0 && article.isExclusive && (
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-foreground-950/80 text-white text-xs font-medium whitespace-nowrap">
                    独家
                  </span>
                )}
                {article.isVideo && (
                  <span className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/50 flex items-center justify-center">
                    <i className="ri-play-fill text-white text-sm"></i>
                  </span>
                )}
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2 leading-snug">
                  {article.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.readCount}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {article.commentCount}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10">
          <Link
            to="/category/mingxing-bagua"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-background-300 text-foreground-600 hover:text-primary-500 hover:border-primary-300 text-sm font-medium transition-all duration-300 whitespace-nowrap"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}